import {ObjectsActionType} from '../ActionType'
import { Dispatch } from 'redux'

/**
 * @typedef Locale Init
 * @returns noting
 * @author IOTA IT
 * @version 0.0.1
 */
export const ObjectsRequestInit = () => {
    return {
        type:ObjectsActionType.Objects_INIT
    }
}

export const ObjectsSuccess = (
    objeckt: any
) => {
    return {
        type: ObjectsActionType.Objects_INIT,
        objeckt: objeckt
    }
}

export const getObjects = (
    objeckt: any[]
) => {
    return (dispatch: Dispatch) => {
        dispatch(
            ObjectsSuccess(
                objeckt
            )
        )
    }
}
